import { observeLazySources } from './modules/lazy-sources-loader.js';

/* need for old browsers without defer */
document.addEventListener(
  `DOMContentLoaded`,
  () => {
    /* initialization of lazy loading */
    observeLazySources();
  },
  false,
);
